import { createContext, useCallback, useMemo, useState } from "react";
import STATIC_FILTER from "../pages/Home/staticFilter";

type AudienceProviderProps = {
  children: React.ReactNode;
};

export type AudienceContextData = {
  filtroConsulta: any;
  filtroSegmentacao: any;
  filtroSelecionado: any;
  reprocessoAudiencia: any;
  setFiltroConsulta: any;
  setFiltroSegmentacao: any;
  setFiltroSelecionado: any;
  setReprocessoAudiencia: any;
  STATIC_FILTER: any;
  handleReset: () => void;
};

export const AudienceContext = createContext<AudienceContextData>(
  {} as AudienceContextData
);

export function AudienceProvider({ children }: AudienceProviderProps) {
  const [filtroConsulta, setFiltroConsulta] = useState(STATIC_FILTER);
  const [filtroSegmentacao, setFiltroSegmentacao] = useState(STATIC_FILTER);
  const [filtroSelecionado, setFiltroSelecionado] = useState({});
  const [reprocessoAudiencia, setReprocessoAudiencia] = useState({});

  const handleReset = useCallback(() => {
    setFiltroConsulta(STATIC_FILTER);
    setFiltroSegmentacao(STATIC_FILTER);
    setFiltroSelecionado({});
    setReprocessoAudiencia({});
  }, []);

  const audienceContextData = useMemo(() => {
    return {
      filtroConsulta,
      filtroSegmentacao,
      filtroSelecionado,
      reprocessoAudiencia,
      setFiltroConsulta,
      setFiltroSegmentacao,
      setFiltroSelecionado,
      setReprocessoAudiencia,
      handleReset,
      STATIC_FILTER,
    };
  }, [
    filtroConsulta,
    filtroSegmentacao,
    filtroSelecionado,
    reprocessoAudiencia,
    setFiltroConsulta,
    setFiltroSegmentacao,
    setFiltroSelecionado,
    setReprocessoAudiencia,
    handleReset,
  ]);

  return (
    <AudienceContext.Provider value={audienceContextData}>
      {children}
    </AudienceContext.Provider>
  );
}
